// Module
var code = "<p class=\"circle\">3</p> <p>Tap the <strong>Payment</strong> button.</p> ";
// Exports
export default code;